/* eslint-disable camelcase */
import _ from 'lodash';
import * as types from '@/store/types';
import { serviceIdToInstantQuote } from '@/constants';

export default {
    state: {
        selectableQuotes: [
            {
                name: 'Bush Trimming',
                service_id: 8,
            },
            {
                name: 'Leaf Removal',
                service_id: 10,
            },
            {
                name: 'Cleanups',
                service_id: 7,
            },
            {
                name: 'Landscaping',
                service_id: 9,
            },
            {
                name: 'Tree Care',
                service_id: 3,
            },
            {
                name: 'Other',
                service_id: 18,
            },
        ],
    },

    actions: {
        /**
         * Looks at existing quotes in the cart, compared to a service_id depending on if it is in
         * the cart or not will determine what additional actions are dispatched
         * @param getters
         * @param dispatch
         * @param name
         * @param service_id
         */
        [types.OTHER_SERVICES__TOGGLE_SELECTABLE_QUOTE](
            { getters, dispatch, rootState },
            { name, service_id }
        ) {
            if (service_id === 8 || service_id === 10) {
                const instantQuoteInCart = _.find(rootState.cart.instant_quotes, {
                    type: serviceIdToInstantQuote[service_id].type,
                });

                // do not make call if it's the temporary instant quote
                if (
                    _.get(instantQuoteInCart, 'id') === serviceIdToInstantQuote[service_id].dummyId
                ) {
                    return;
                }

                if (instantQuoteInCart) {
                    dispatch(types.CART__REMOVE_INSTANT_QUOTE_FROM_CART, instantQuoteInCart);
                } else {
                    dispatch(types.CART__ADD_INSTANT_QUOTE_TO_CART, service_id);
                }
                return;
            }

            const quotesInCartByServiceId =
                getters[types.OTHER_SERVICES__GET_QUOTES_IN_CART_BY_SERVICE_ID];
            const quoteInCart = _.get(quotesInCartByServiceId, `[${service_id}]`);
            if (quoteInCart) {
                dispatch(types.CART__REMOVE_QUOTE_FROM_CART, { name, service_id });
            } else {
                dispatch(types.CART__ADD_QUOTE_TO_CART, { name, service_id });
            }
        },
    },

    getters: {
        /**
         * Gets quotes in cart, returns an object with keys as the service_id and the value as the
         * quote that is in the cart for that service_id
         * @param localState
         * @param otherGetters
         * @return {*}
         */
        [types.OTHER_SERVICES__GET_QUOTES_IN_CART_BY_SERVICE_ID](localState, otherGetters) {
            const quotesInCart = otherGetters[types.CART__GET_QUOTES_IN_CART];

            return _.reduce(
                quotesInCart,
                (result, quote) => {
                    const quoteServiceId = _.get(quote, 'service.service_id');
                    // eslint-disable-next-line no-param-reassign
                    result[quoteServiceId] = quote;
                    return result;
                },
                {}
            );
        },
    },
};
